var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader',{attrs:{"title":"จัดการหมวดหมู่คอร์ส"}}),_c('b-row',{staticClass:"justify-content-center m-5"},[_c('b-col',{attrs:{"cols":"12"}},[_c('TagList',{attrs:{"apiRoute":`/v1/tags/get-available-tags`,"apiRoute2":`/v1/tags/get-company-course-tags`}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }